export const BLOG_TAG_LABELS: Record<string, string> = {
  events: "blogTagEvents",
  partnerships: "blogTagPartnerships",
  products: "blogTagProducts",
  software: "blogTagSoftware",
  company: "blogTagCompany",
};
